<app-card icon="arrow_back"
		  preCardTitle="Manage Vehicle Groups"
		  (iconClicked)="goBack()">
	<div *appCardContentRaw>
		@if (isLoading) {
			<mat-progress-spinner mode="indeterminate"
								  class="mx-a my-16"
								  diameter="30">
			</mat-progress-spinner>
		} @else {
			<mat-list class="raw-card-list">
			@for (group of groups; track group.id) {
				<mat-list-item>
					<div matListItemTitle>{{ group.name }}</div>
					<div matListItemMeta>
						<button mat-icon-button
								(click)="deleteGroup(group)">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</mat-list-item>
			}
			</mat-list>
		}
	</div>
</app-card>
